import { ContentConverter } from './ContentConverter';
import { ContentTypeServerEnum } from './ContentItem';
import { convertToNavigationRestriction } from './propertiesConverter';
import { RestrictionConverter } from './restrictionConverter';
import { StartingMessageHelper } from '../content/StartingMessage';
import { createParentId } from '../content/parentId';
export const convertToStartingMessage = (startingMessageServer, parentItemId) => {
    const { guid, title, trackingIdentifier, referenceIdentifier, audioAsset, properties } = startingMessageServer;
    return StartingMessageHelper.build({
        title: title,
        content: ContentConverter.convertToDomainModel(startingMessageServer.content),
        restriction: convertToNavigationRestriction(properties),
        trackingIdentifier: trackingIdentifier,
        audioAsset: audioAsset,
        id: guid,
        referenceIdentifier: referenceIdentifier,
        parentId: createParentId(parentItemId),
    });
};
export const convertStartingMessageToUpdateServerModel = (item) => {
    return {
        guid: item.id,
        title: item.title,
        content: ContentConverter.convertToServerModel(item.content),
        audioAsset: item.audioAsset,
        properties: {
            navigation: RestrictionConverter.toServerModel(item.restriction),
        },
        referenceIdentifier: item.referenceIdentifier,
    };
};
export const convertStartingMessageToCreateServerModel = (item, itemId) => {
    return {
        ...convertStartingMessageToUpdateServerModel(item),
        itemType: ContentTypeServerEnum.StartingMessage,
        trackingIdentifier: item.trackingIdentifier,
        itemId: itemId,
        referenceIdentifier: item.referenceIdentifier,
    };
};
